import { observer } from 'mobx-react';
import ProfilerTeamDesktop from './desktop/ProfilerTeamDesktop';
import { useEffect } from 'react';

const ProfilerTeam = observer(() => {
  useEffect(() => {
    document.title = `transact.digital GmbH - Team`;
  }, []);

  return <ProfilerTeamDesktop />;
});

export default ProfilerTeam;
